// extracted by mini-css-extract-plugin
module.exports = {"FooterLegal":"FooterLegal_FooterLegal__1WNoi","FooterLegalInner":"FooterLegal_FooterLegalInner__25MDw","FooterLegalSmall":"FooterLegal_FooterLegalSmall__yU6U4"};